// @core/api/endpoints/tenant/update_tenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantResponse,
  UpdateTenantRequest,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Update tenant
 * Updates tenant information including name, description, and settings. Requires admin privileges on the tenant.
 */
export async function UpdateTenant(
  tenant_id: string,
  data: UpdateTenantRequest,
  options?: RequestOptions
): Promise<TenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.put<TenantResponse>(requestPath, data, requestOptions);
}
